import { render } from "./create_rfc_modal.vue?vue&type=template&id=1c3891d8"
import script from "./create_rfc_modal.vue?vue&type=script&lang=js"
export * from "./create_rfc_modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__